/*
 *
 * Communications constants
 *
 */

export const FLUSH_STATE_COMMUNICATIONS =
  'app/Communications/FLUSH_STATE_COMMUNICATIONS';

export const INITIAL_ID = 'app/Communications/INITIAL_ID';

// LOAD
export const LOAD_COMMUNICATIONS = 'app/Communications/LOAD_COMMUNICATIONS';
export const LOAD_COMMUNICATIONS_SUCCESS = 'app/Communications/LOAD_COMMUNICATIONS_SUCCESS';
export const LOAD_COMMUNICATIONS_ERROR = 'app/Communications/LOAD_COMMUNICATIONS_ERROR';

// LOAD ITEM Single
export const LOAD_COMMUNICATION = 'app/Communications/LOAD_COMMUNICATION';
export const LOAD_COMMUNICATION_SUCCESS = 'app/Communications/LOAD_COMMUNICATION_SUCCESS';
export const LOAD_COMMUNICATION_ERROR = 'app/Communications/LOAD_COMMUNICATION_ERROR';
// LOAD ITEM ANSWERS
export const LOAD_COMMUNICATION_ANSWERS = 'app/Communications/LOAD_COMMUNICATION_ANSWERS';
export const LOAD_COMMUNICATION_ANSWERS_SUCCESS = 'app/Communications/LOAD_COMMUNICATION_ANSWERS_SUCCESS';
export const LOAD_COMMUNICATION_ANSWERS_ERROR = 'app/Communications/LOAD_COMMUNICATION_ANSWERS_ERROR';

// UPDATE ITEM ANSWERS
export const UPDATE_COMMUNICATION_ANSWERS = 'app/Communications/UPDATE_COMMUNICATION_ANSWERS';
export const UPDATE_COMMUNICATION_ANSWERS_SUCCESS = 'app/Communications/UPDATE_COMMUNICATION_ANSWERS_SUCCESS';
export const UPDATE_COMMUNICATION_ANSWERS_ERROR = 'app/Communications/UPDATE_COMMUNICATION_ANSWERS_ERROR';

// CHANGE/UPDATE Single
export const UPDATE_COMMUNICATION = 'app/Communications/CHANGE_COMMUNICATION';
export const UPDATE_COMMUNICATION_SUCCESS =
  'app/Communications/CHANGE_COMMUNICATION_SUCCESS';
export const UPDATE_COMMUNICATION_ERROR =
  'app/Communications/CHANGE_COMMUNICATION_ERROR';

// DELETE Single
export const HARD_DELETE_COMMUNICATION = 'app/Communications/HARD_DELETE_COMMUNICATION';
export const HARD_DELETE_COMMUNICATION_SUCCESS = 'app/Communications/HARD_DELETE_COMMUNICATION_SUCCESS';
export const HARD_DELETE_COMMUNICATION_ERROR = 'app/Communications/HARD_DELETE_COMMUNICATION_ERROR';

// COPY Single
export const COPY_COMMUNICATION = 'app/Communications/COPY_COMMUNICATION';
export const COPY_COMMUNICATION_SUCCESS = 'app/Communications/COPY_COMMUNICATION_SUCCESS';
export const COPY_COMMUNICATION_ERROR = 'app/Communications/COPY_COMMUNICATION_ERROR';

// COPY Single
export const UPDATE_ACTIVE_COMMUNICATION = 'app/Communications/UPDATE_ACTIVE_COMMUNICATION';
export const UPDATE_ACTIVE_COMMUNICATION_SUCCESS = 'app/Communications/UPDATE_ACTIVE_COMMUNICATION_SUCCESS';
